import { createPriceAdjustmentHandler, pricedRowsForLine } from "./priceAdjustment";

/**
 * G5 — Tiered Price Adjustment (type "TPA"). Each X-product row is a tier:
 *   quantity = minimum quantity on the line for the tier, price = unit price at that tier.
 * The line takes the tier with the largest quantity it reaches, and every unit is charged at that
 * tier's price, e.g. tiers 1 → ₹50, 6 → ₹45, 12 → ₹40 on qty 7 = 7 × 45.
 * Below the first tier, or when the tier price is not lower than the regular price, the rule does
 * not apply (null). The header minimumQty, when set, is an extra gate.
 */
export const resolveTieredUnitTotal = (pricingRule, line, qty, realPrice) => {
  const minQty = Number(pricingRule.minimumQty) > 0 ? Number(pricingRule.minimumQty) : 0;
  if (!(qty > 0) || qty < minQty) return null;

  const tiers = pricedRowsForLine(pricingRule, line).filter((row) => (Number(row.quantity) || 1) <= qty);
  if (tiers.length === 0) return null;
  const tier = tiers.reduce((a, b) => ((Number(b.quantity) || 1) > (Number(a.quantity) || 1) ? b : a));

  const total = Number(tier.price) * qty;
  if (!(total >= 0) || total >= realPrice * qty) return null;
  return total;
};

export const tieredPriceAdjustment = createPriceAdjustmentHandler(resolveTieredUnitTotal);
